export interface IMap<T> {
  [key: string]: T;
}
const constructErrorMessage = (errorObj?: IMap<string>) => {
  let errorMsg = '';
  for (const key in errorObj) {
    if (errorObj[key as string].length) {
      for (const msg of errorObj[key as string]) {
        if (msg) {
          errorMsg = `${errorMsg} ${msg}`;
        }
      }
    }
    errorMsg = `${errorMsg} \n`;
  }

  if (!errorMsg.trim().length) {
    errorMsg = 'Something went wrong. Please contact your administrator';
  }
  return errorMsg.trim();
};

export const getError = <T>(err: T) => {
  if (Array.isArray((err as any)?.errors)) {
    return constructErrorMessage({ message: (err as any).errors });
  }
  const error = err as { response: { data: { message: string } } };
  const validationErrors = err as { response: { data: { errors: { [key: string]: string } } } };
  return constructErrorMessage(validationErrors?.response?.data?.errors || { message: [error?.response?.data?.message] });
};

export const roundAccurately = (value: number, decimalPlaces: number) =>
  Number(Math.round(Number(value + 'e' + decimalPlaces)) + 'e-' + decimalPlaces);

export const formatCurrency = (value?: number | string) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formatter.format((value || '0') as number);
};

export const validateAndOpenUrl = (url: string): void => {
  try {
    const validatedUrl = new URL(url);
    window.open(validatedUrl.toString(), '_blank', 'noopener,noreferrer');
  } catch (err) {
    console.error('Malformed URL:', err);
    throw new Error(`Invalid URL: ${url}`);
  }
};